import { render, staticRenderFns } from "./Talentside.vue?vue&type=template&id=6ca4e94a&scoped=true&"
import script from "./Talentside.vue?vue&type=script&lang=js&"
export * from "./Talentside.vue?vue&type=script&lang=js&"
import style0 from "./Talentside.vue?vue&type=style&index=0&id=6ca4e94a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4e94a",
  null
  
)

export default component.exports